// @flow
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Pill, pillSizes, pillColours } from 'moods-react/Pill';

import Tooltip from '../../../common/tooltip/TooltipComponent';
import SpeechBubbleComponent from '../../../common/speech-bubble/SpeechBubbleComponent';

import './SideNavItem.scss';

type Props = {
  title: string,
  name: string,
  url: string,
  icon: Element,
  active: boolean,
  onClick: () => void,
  link: boolean,
  dataQaId: string,
  dataTourStep: string,
  badgeValue: number,
  announcementMsg: {
    title: string,
    body: string,
    callout: string,
    onDismiss: Function,
  },
};

const getTooltip = (title: string, hideTooltip: boolean) => {
  return hideTooltip ? null : <Tooltip label={title} theme="standalone" position="left" />;
};

const getBadgeIcon = (badgeValue: number) => {
  return badgeValue ? (
    <Pill className="side-nav-item-component__badge" size={pillSizes.SMALL} colour={pillColours.BLUEBERGINE}>
      {badgeValue}
    </Pill>
  ) : null;
};

const getAnnouncementMessage = (announcementMsg: Object) => {
  return announcementMsg ? (
    <div className="side-nav-item-component__announcement u-display-none@until-medium">
      <SpeechBubbleComponent
        title={announcementMsg.title}
        body={announcementMsg.body}
        callout={announcementMsg.callout}
        onClose={announcementMsg.onDismiss}
      />
    </div>
  ) : null;
};

const SideNavItemComponent = (props: Props): Element => {
  const { active, onClick, name, url, dataQaId, link, icon, title, dataTourStep, announcementMsg, badgeValue } = props;

  const activeClass = active ? 'active' : '';
  const linkProps = {
    onClick,
    className: `${activeClass} side-nav-item-component__anchor side-nav-item-component__anchor--${name}`,
    to: url,
    href: url,
    'data-qa-id': dataQaId,
  };

  const tagName = link ? Link : 'a';
  const linkElement = React.createElement(
    tagName,
    linkProps,
    <span>
      {icon}
      {getTooltip(title, !!announcementMsg)}
      {getBadgeIcon(badgeValue)}
    </span>,
  );

  return (
    <li className="side-nav-item-component" data-qa-id="navigation-list-item" data-tour-step={dataTourStep}>
      {linkElement}
      {getAnnouncementMessage(announcementMsg)}
    </li>
  );
};

SideNavItemComponent.displayName = 'SideNavItem';

SideNavItemComponent.propTypes = {
  title: PropTypes.string,
  name: PropTypes.string,
  url: PropTypes.string,
  icon: PropTypes.element,
  active: PropTypes.bool,
  onClick: PropTypes.func,
  link: PropTypes.bool,
  dataQaId: PropTypes.string,
  dataTourStep: PropTypes.string,
  badgeValue: PropTypes.string,
};

SideNavItemComponent.defaultProps = {
  title: '',
  active: false,
  onClick() {},
  dataQaId: '',
  dataTourStep: '',
};

export default SideNavItemComponent;
